import React from 'react'
import clsx from "clsx"

const LoginFailedPopup = ({close, onTryAgain}) => {
    return (
        <div className="PopupModalOverlay" onClick={close}>
            <div className="PopupModal w-[480px]"
                 onClick={(e) => e.stopPropagation()}>
                <div className="w-full flex flex-col items-center gap-4 px-5 py-4">
                    <div className="flex items-start justify-between gap-3 w-full">
                        <div className="LoginFailed">
                            <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                                <span className="text-white text-sm font-bold">!</span>
                            </div>
                        </div>
                        <button onClick={ close } className="flex-shrink-0">
                            <img alt="Close" src="/media/icons/close-dark.svg" className="w-5 h-5"/>
                        </button>
                    </div>
                    <div className={"flex flex-col gap-3"}>
                        <div className="BaseSemiBoldText">Login Failed</div>
                        <div className="XSmallLightGrayText">
                            The username or password you entered is incorrect. Please check your credentials and try again.
                        </div>
                    </div>
                </div>

                <div className="PopupFooter">
                    <div className="flex gap-3 items-end justify-end">
                        <button
                            type="button"
                            className={ clsx("SecondaryButton", "w-[110px]") }
                            onClick={ close }
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className={ clsx("PrimaryButton", "w-[110px]") }
                            onClick={ onTryAgain }
                        >
                            Try again
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginFailedPopup 